/**
 * @file schedule-for-next-day-span.tsx
 * @module app/modules/_common/components/schedule-for-next-day-span
 * @description Reusable component to display scheduled for next day delivery status icon with tooltip.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.0
 * @version 1.3.0
 */

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { ScheduleForNextDayMsg } from '../../../../utils/common.constants';
import statusCircleIcon from '../../../../_admin/assets/media/svg_uTrade/forward.svg';

interface ScheduleForNextDaySpanProps {
  className?: string;
  msg?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const ScheduleForNextDaySpan: React.FC<ScheduleForNextDaySpanProps> = ({
  className = 'ms-2',
  msg = '',
  placement = 'top',
}) => {
  return (
    <span
      className={`${className} border border-light rounded p-2 release-highlighter--schedule-for-next-day`}
    >
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement={placement}
        overlay={
          <Popover className="bg-dark">
            <Popover.Body className="text-white fw-500 py-2 px-3">
              {ScheduleForNextDayMsg + ' ' + msg}
            </Popover.Body>
          </Popover>
        }
      >
        <img
          width={20}
          height={20}
          src={statusCircleIcon}
          alt="Status Info"
          className="cursor-pointer"
        />
      </OverlayTrigger>
    </span>
  );
};

export default ScheduleForNextDaySpan;
